export default {
    defaultProps: {
        disableRipple: true,
        disableElevation: true,
    },
    styleOverrides: {
        root: {
            textTransform: 'none',
        },
    },
};
//# sourceMappingURL=MuiButton.js.map